import { ShieldCheck } from "lucide-react";
import { Reveal } from "./shared";

const LOGOS = [
  { src: "/assets/cert-abrinstal.png", alt: "Abrinstal — Associação Brasileira pela Conformidade e Eficiência de Instalações" },
  { src: "/assets/cert-bip.png", alt: "BIP — Building Installation Performance" },
  { src: "/assets/cert-comgas.png", alt: "Comgás" },
];

export const Certifications = () => (
  <section className="border-b border-zinc-100 bg-white py-16 sm:py-20" data-testid="certifications-section">
    <div className="mx-auto max-w-4xl px-5 text-center lg:px-8">
      <Reveal>
        <span className="inline-flex items-center gap-2 rounded-full border border-[var(--primary)]/40 bg-[var(--primary)]/10 px-4 py-1.5">
          <ShieldCheck size={15} className="text-[#E8A200]" />
          <span className="font-display text-xs font-bold uppercase tracking-[0.25em] text-[#E8A200]">
            Certificada e autorizada
          </span>
        </span>
        <p className="mx-auto mt-6 max-w-3xl text-base leading-relaxed text-zinc-600 sm:text-lg" data-testid="certifications-text">
          Certificada e autorizada para instalações e manutenções, com treinamento técnico avançado
          e <b className="text-zinc-900">Certificação Abrinstal – BIP (Building Installation Performance)</b>,
          garantindo qualidade e segurança em cada serviço.
        </p>
      </Reveal>
      <Reveal delay={0.15} className="mt-10 flex flex-wrap items-center justify-center gap-8 sm:gap-14" data-testid="certifications-logos">
        {LOGOS.map((logo, i) => (
          <img
            key={logo.src}
            src={logo.src}
            alt={logo.alt}
            loading="lazy"
            data-testid={`certification-logo-${i}`}
            className="h-14 w-auto object-contain transition-transform duration-300 hover:scale-110 sm:h-16"
          />
        ))}
      </Reveal>
    </div>
  </section>
);
